import _ from 'underscore';
import Backbone from 'backbone';
import PopularityRoute from 'models/course/PopularityRoute';
import MapViewUtils from 'views/map/MapViewUtils';
import Util from 'views/utils/LeafletMap/utils/Util';

export default Backbone.Collection.extend({
    model: PopularityRoute,
    urlRoot: '/course-service/course/popularRoutes',

    backend: 'gcapi',

    url: function() {
        if (MapViewUtils.userInChina()) {
            return (
                this.urlRoot +
                '?sourceCoordinateSystem=' +
                Util.CoordinateSystem.BD09 +
                '&targetCoordinateSystem=' +
                Util.CoordinateSystem.BD09 +
                '&startLat=' +
                this.startLat +
                '&startLon=' +
                this.startLon +
                '&endLat=' +
                this.endLat +
                '&endLon=' +
                this.endLon +
                (this.courseType ? '&courseType=' + this.courseType : '')
            );
        } else {
            return (
                this.urlRoot +
                '?startLat=' +
                this.startLat +
                '&startLon=' +
                this.startLon +
                '&endLat=' +
                this.endLat +
                '&endLon=' +
                this.endLon +
                (this.courseType ? '&courseType=' + this.courseType : '')
            );
        }
    },

    initialize: function(args) {
        if (!args.startLat) {
            throw 'startLat is required';
        }
        if (!args.startLon) {
            throw 'startLon is required';
        }
        if (!args.endLat) {
            throw 'endLat is required';
        }
        if (!args.endLon) {
            throw 'endLon is required';
        }

        this.courseType = args.courseType;
        this.startLat = args.startLat;
        this.startLon = args.startLon;
        this.endLat = args.endLat;
        this.endLon = args.endLon;
    },

    parse: function(response) {
        if (response) {
            var points = [];

            _.each(response, function(a) {
                _.each(a, function(p) {
                    points.push({
                        latitude: p[0],
                        longitude: p[1]
                    });
                });
            });

            return points;
        }
    }
});
